var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BackdataCard,{attrs:{"title":_vm.title,"headers":_vm.headers,"items":_vm.items,"openCreateDialog":_setup.openCreateDialog,"openEditDialog":_setup.openEditDialog,"openDeleteDialog":_setup.openDeleteDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }